import { render, staticRenderFns } from "./AddAnnouncements.vue?vue&type=template&id=17333358&scoped=true"
import script from "./AddAnnouncements.vue?vue&type=script&lang=js"
export * from "./AddAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./AddAnnouncements.vue?vue&type=style&index=0&id=17333358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17333358",
  null
  
)

export default component.exports